import * as domain from '@packages/domain'
import { useApi } from '~/api'

export const useElevenLabsTTS = () => {
  const [generateAudio, audio] = useApi(domain.Api.ElevenLabsTTS.generateAudio)
  return {
    audio,
    generateAudio: (text: string) => generateAudio({ text })
  }
}
